import {Collaborator} from 'auth/PermissionConstants';
import {NavStoreProject} from 'constants/SourceConstants';

export interface SectionFilter {
  id: string | null;
  name: string;
}

export interface Section {
  collapsed: boolean;
  id: string;
  name: string;
  showTitle: boolean;
  filterFn?: (source: NavStoreProject, currentFilter: SectionFilter) => Array<Collaborator>;
  sortFn?: (source: NavStoreProject) => number;
  filterOptions?: Array<SectionFilter>;
  renderEmptySection?: (currentFilter: SectionFilter) => JSX.Element;
}

export enum ProjectAttributeFilterValue {
  ALL_ACTIVE = 'ALL_ACTIVE',
  STARRED = 'STARRED',
  HIDDEN = 'HIDDEN',
  ARCHIVED = 'ARCHIVED',
}

export const ProjectPreferences = {
  LAST_SELECTED_PROJECT_FILTER: 'projects.lastProjectFilter',
  SECTION_COLLAPSED: 'project_section_collapsed',
  LAST_SELECTED_PROJECT_ATTRIBUTE_FILTER: 'projects.lastAttributeFilter',
};
